import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JsonObjectFactoryService } from '../../../global/services/json-object-factory.service';

@Injectable({
  providedIn: 'root',
})
export class ScreensService {
  constructor(
    private http: HttpClient,
    private jsonObjectFactory: JsonObjectFactoryService,
  ) {}

  /**
   * Load screen data - action_id 78.
   */
  loadScreen(
    baseUrl: string,
    screenKey: string,
    clientKey: string,
    versionNum?: number,
    globalParams?: any
  ): Observable<any> {
    const merged: any = {
      ...(globalParams || {}),
      screen_key: screenKey,
      client_key: clientKey,
      action_id: 78,
    };
    if (versionNum != null) {
      merged.version_num = versionNum;
    }
    delete merged.checkLockedbj;

    let httpParams = new HttpParams();
    Object.keys(merged).forEach(key => {
      const val = merged[key];
      if (val !== undefined && val !== null && val !== '') {
        httpParams = httpParams.set(key, String(val));
      }
    });

    return this.http.get<any>(baseUrl + '/loadJsonObject', {
      params: httpParams,
      withCredentials: true,
    });
  }

  /**
   * Load roles for JCD - action_id 81.
   */
  loadRoles(
    baseUrl: string,
    jcdTaKey: number | string,
    clientKey: string
  ): Observable<any> {
    return this.http.get<any>(baseUrl + '/loadJsonObject', {
      params: {
        action_id: 81,
        jcd_ta_key: String(jcdTaKey),
        client_key: clientKey,
      },
      withCredentials: true,
    });
  }

  /**
   * Load filter groups - action_id 1102.
   */
  loadFilterGroup(baseUrl: string, clientKey: string): Observable<any> {
    return this.http.get<any>(baseUrl + '/loadJsonObject', {
      params: { action_id: 1102, client_key: clientKey },
      withCredentials: true,
    });
  }

  /**
   * Save screen - POST to admin_api_url/saveScreen.
   * Uses JsonObjectFactoryService.saveJSON to automatically include
   * jcd_key, issue_id, issue_short_desc, checkLockedbj, tax_year, scenario.
   */
  saveScreen(
    adminApiUrl: string,
    payload: { screen_key?: string | number; activity_key: string | number; json_string: string }
  ): Observable<any> {
    return this.jsonObjectFactory.saveJSON(adminApiUrl + '/saveScreen', payload);
  }

  /**
   * Get screen tags - POST admin_api_url/getScreenTagging.
   * Returns { tags_list, selected_tags_list }.
   */
  getScreenTagging(
    adminApiUrl: string,
    screenKey: string | number,
    clientKey: string
  ): Observable<any> {
    const params = new HttpParams()
      .set('screen_key', String(screenKey))
      .set('client_key', clientKey);
    return this.http.post<any>(adminApiUrl + '/getScreenTagging', null, {
      params,
      withCredentials: true,
    });
  }

  /**
   * Save screen tags - POST base_url/saveJsonObject?action_id=31623.
   */
  saveScreenTags(
    baseUrl: string,
    screenKey: string | number,
    tagsData: any[],
    clientKey: string
  ): Observable<any> {
    const body = new URLSearchParams();
    body.set('screen_key', String(screenKey));
    body.set('data', JSON.stringify(tagsData));
    body.set('client_key', clientKey);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    return this.http.post<any>(baseUrl + '/saveJsonObject?action_id=31623', body.toString(), {
      headers,
      withCredentials: true,
    });
  }

  /**
   * Get screen tax categories - POST admin_api_url/getScreenTaxCategories.
   * Returns { tax_types_list, categories_list }.
   */
  getScreenTaxCategories(adminApiUrl: string): Observable<any> {
    return this.http.post<any>(adminApiUrl + '/getScreenTaxCategories', null, {
      withCredentials: true,
    });
  }

  /**
   * Get scenario type codes - GET base_url/getScenarioTypeCodes.
   */
  getScenarioTypeCodes(baseUrl: string): Observable<any> {
    return this.http.get<any>(baseUrl + '/getScenarioTypeCodes', {
      withCredentials: true,
    });
  }
}
